export const MARKETING_CAMPAIGN_QUERY_KEY = 'marketingCampaign'
export const MARKETING_CAMPAIGN__BY_ID_QUERY_KEY = 'marketingCampaignById'
export const ANONYMOUSLY_MARKETING_CAMPAIGN_QUERY_KEY = 'anonymouslyMarketingCampaign'
